import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Heading, SimpleGrid } from '@chakra-ui/react';
import PlanCard from './PlanCard';
import BackgroundWrapper from 'components/Background/Background';

const PricingPage = () => {
  // const state = useSelector((state) => state);
  // console.log('state in pricing page: ', state);
  const user = useSelector((state) => state.user?.info);

  const plans = [
    {
      name: 'Free Trial',
      price: null,
      originalPrice: '0',
      priceId: '0',
      isFree: true,
      details: [
        'Access to All Writing Features',
        'Priority Customer Support',
        'Up to 14 Days of Writing Access',
      ],
    },
    {
      name: 'Pro Monthly',
      originalPrice: '9.99',
      price: '6.99',
      priceId: 'price_1QsQltBydazMi0KpGDuBv5pi',
      isFree: false,
      details: [
        'Access to All Writing Features',
        'Unlimited Writing Opportunities',
        'Detailed Progress Tracking',
        'Priority Customer Support',
        'Flexible Cancel Anytime Option',
      ],
      isMostPopular: false,
    },
    {
      name: 'Pro Yearly',
      originalPrice: '99.99',
      price: '69.99',
      priceId: 'price_1QsQltBydazMi0KpWOzDIJJy',
      isFree: false,
      details: [
        'Access to All Writing Features',
        'Unlimited Writing Opportunities',
        'Detailed Progress Tracking',
        'Priority Customer Support',
        'Flexible Cancel Anytime Option',
        'Exclusive Annual Billing Discount',
      ],
    },
  ];

  return (
    <BackgroundWrapper applyMd={false}>
      <Box
        p={8}
        maxWidth={{ base: '90%', md: '70%', lg: '95%' }}
        mx="auto"
        my={12}
      >
        <Heading mb={8}>Choose Your Plan</Heading>
        <SimpleGrid
          columns={{ base: 1, lg: 3 }}
          spacing={{ base: '40px', md: '40px', lg: '40px' }}
        >
          {plans.map((plan, index) => (
            <PlanCard
              key={index}
              name={plan.name}
              price={plan.price}
              originalPrice={plan.originalPrice}
              priceId={plan.priceId}
              details={plan.details}
              isFree={plan.isFree}
              isMostPopular={plan.isMostPopular}
              user={user}
            />
          ))}
        </SimpleGrid>
      </Box>
    </BackgroundWrapper>
  );
};

export default PricingPage;
